<script setup lang="ts">
const items = [
  {
    title: 'Hemat Waktu Operasional',
    description: 'Ratusan pesanan dikirim hanya dalam satu langkah.',
    icon: 'material-symbols:timer-outline'
  },
  {
    title: 'Minim Kesalahan Input',
    description: 'Sistem validasi otomatis untuk alamat & data penerima.',
    icon: 'material-symbols:fact-check-outline'
  },
  {
    title: 'Pantau Semua Ekspedisi',
    description: 'Satu dashboard untuk semua status pengiriman.',
    icon: 'material-symbols:visibility-outline'
  },
  {
    title: 'Skalabilitas Tinggi',
    description:
      'Cocok untuk aggregator & seller besar tanpa tambah beban kerja.',
    icon: 'material-symbols:arrow-upward'
  },
  {
    title: 'Integrasi Fleksibel',
    description: 'Dukung File Excel/CSV dan Sinkronisasi Webstore/API',
    icon: 'material-symbols:all-inclusive'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    title="Optimalkan Operasional, Minimalkan Kesalahan"
    hero-image="/images/kirim-paket-massal-banner-3.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
